import { Component, Input, ElementRef, ViewChild, OnChanges } from '@angular/core';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { TramoLicitacion } from 'src/app/models/entities/tramo-licitacion';

@Component({
  selector: 'formato-pdf-incidencia-obra',
  templateUrl: './formato-pdf-incidencia-obra.component.html',
  styleUrls: ['./formato-pdf-incidencia-obra.component.scss']
})
export class FormatoPdfIncidenciaObraComponent implements OnChanges {

  @ViewChild('formatoHtmlPDF')
  public formatoHtmlPDF: ElementRef;

  @Input('tramoLicitacion')
  public tramoLicitacion: TramoLicitacion;
  public empresas: any[] = [];
  public diasHabiles: number;
  public nombreEmpresa: string;

  constructor(
    private catalogoService: CatalogoService
  ) { }

  public ngOnChanges(): void {
    // this.catalogoService.obtenerNombreEmpresas().subscribe(
    //   (empresas: any[]) => {
    //     this.empresas = empresas;
    //     this.nombreEmpresa = this.empresas[parseInt(this.tramoLicitacion.keyCatEmpresa)];
    //   }
    // );
    let fechaInicio = new Date(this.tramoLicitacion.fechaInicio).getTime();
    let fechaFin = new Date(this.tramoLicitacion.fechaFin).getTime();
    let time = fechaFin - fechaInicio;
    this.diasHabiles = Math.round(time / (1000 * 3600 * 24));
  }

}